// context/FocusContext.js
import React, { createContext, useContext, useRef } from 'react';

const FocusContext = createContext();

export const FocusProvider = ({ children }) => {
  const lastFocusedElement = useRef(null);

  const registerFocus = (elementRef) => {
    lastFocusedElement.current = elementRef;
  };

  const restoreFocus = () => {
    if (lastFocusedElement.current) {
      lastFocusedElement.current.focus();
    }
  };

  return (
    <FocusContext.Provider value={{ registerFocus, restoreFocus }}>
      {children}
    </FocusContext.Provider>
  );
};

export const useFocus = () => useContext(FocusContext);